import 'rc-drawer/assets/index.css'
import React, { useContext } from 'react'
import DrawerMenu from 'rc-drawer'
import { useDispatch, useSelector } from 'react-redux'
import { apiContext } from 'services/ApiContext'
import MenuLeft from './MenuLeft'
import MenuTop from './MenuTop'

const AppMenu = (props) => {
  const dispatch = useDispatch()
  const { customMenuData = [] } = props
  const { isMenuTop, isMobileMenuOpen, isMobileView, isLightTheme } = useSelector(
    (state) => state.settings,
  )
  const { userId, project, projects, user } = useContext(apiContext)

  const toggleOpen = () => {
    document
      .querySelector('#root')
      .setAttribute(
        'style',
        !isMobileMenuOpen ? 'overflow: hidden; width: 100%; height: 100%;' : '',
      )
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'isMobileMenuOpen',
        value: !isMobileMenuOpen,
      },
    })
  }

  const menuProps = { userId, project, projects, user, customMenuData }

  const BootstrappedMenu = () => {
    if (isMobileView) {
      return (
        <DrawerMenu
          getContainer={null}
          level={null}
          open={isMobileMenuOpen}
          onClose={toggleOpen}
          onHandleClick={toggleOpen}
          className={isLightTheme ? 'drawer-light' : ''}
        >
          <MenuLeft {...menuProps} />
        </DrawerMenu>
      )
    }
    if (isMenuTop) {
      return <MenuTop {...menuProps} />
    }
    return <MenuLeft {...menuProps} />
  }

  return BootstrappedMenu()
}

export default AppMenu
